import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { ExternGuidesDocument } from 'src/app/shared/models/ExternGuidesDocument';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { AuthenticationService } from 'src/app/_services';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';

@Component({
  selector: 'app-extern-guides',
  templateUrl: './extern-guides.component.html',
  styleUrls: ['./extern-guides.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ExternGuidesComponent implements OnInit {

  /** LABELS */
  translations: Record<string, string> = {};

  /** LIST */
  lstRespTranslate: TranslateRelLabelVO[];
  lstTypesGuide: CategoryLan[];
  lstLevelTypes: CategoryLan[];
  lstFuncTypes: CategoryLan[];
  lstYesNo01: CategoryLan[];
  lstGender: CategoryLan[];
  lstZones: CategoryLan[];

  /** LIST EXTERN GUIDES */
  listExternGuides: ExternGuidesDocument[] = [];
  listImportGuides: JSON[];
  selectedFile: any;

  /** SECURITY */
  token: string;
  security: SecurityDocument;

  /** ERROR & LOADING */
  haserrors: boolean;
  blocked: boolean = true;
  device: string;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService,
    private translationService: TovpilLanguageService,
  ) {
    this.route.queryParams
      .subscribe(
        params => {

          this.token = params.token;
          this.device = params.device;

          if (this.token) {
            if (this.device && (this.device == "BR" || this.device == "USA")) {
              this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
            } else {
              this.getSecurity();
            }
          }

        });
    this.haserrors = true;
  }

  /**
   * The ngOnInit function calls the  method when the component is initialized.
   */
  ngOnInit(): void {
    //this.getSecurity();
  }

  /**
   * The  function asynchronously fetches security data, translates labels, and retrieves
   * catalog types guides.
   */
  async getSecurity() {
    this.blocked = true;
    this.listExternGuides = [];
    this.listImportGuides = [];
    let data = await this.apiService.findSecurityById({ "id": this.token });
    this.security = data;
    await this.getTranslatedLabels();
    await this.getCatalogTypesGuides();
    this.blocked = false;
  }

  /**
   * The function `authenticateByZuul` in TypeScript authenticates a user using a login service and
   * performs additional actions based on the response code.
   * @param {string} user - The `user` parameter in the `authenticateByZuul` function is a string that
   * represents the username or user identifier that will be used for authentication. It is typically
   * used to identify the user who is trying to log in or access a particular resource.
   * @param {string} password - The `password` parameter in the `authenticateByZuul` function is a string
   * that represents the password provided by the user for authentication.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }

  /**
   * The `goBack` function closes the current window.
   */
  goBack() {
    window.close();
  }

  /**
   * The function asynchronously retrieves translated labels using a translation
   * service, handling any errors that may occur.
   */
  async getTranslatedLabels() {
    try {

      await this.translationService.getTranslatedLabels(this.security.language, this.security.region);
      this.translations = this.translationService.getLabels();

    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }

  /**
   * The function `onFileSelect` reads an Excel file, processes its content, and handles any errors that
   * may occur during the process.
   * @param event - The `onFileSelect` function is triggered when a file is selected. The `event`
   * parameter in this function represents the event object that is generated when the file selection
   * event occurs. It contains information about the selected file, such as its name, size, type, and
   * other properties. In this
   */
  onFileSelect(event) {
    this.blocked = true;
    this.selectedFile = event.files[0];
    let reader = new FileReader();
    reader.readAsBinaryString(this.selectedFile);
    let self = this;
    let errorHappen: boolean = false;
    reader.onload = function (e) {

      import("xlsx").then(xlsx => {
        const workbook = xlsx.read(reader.result, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyy', });
        const sheetnames = Object.keys(workbook.Sheets);
        const sheetname = sheetnames[0];
        let respuesta: JSON[] = xlsx.utils.sheet_to_json(workbook.Sheets[sheetname], { defval: "", blankrows: false, header: 1 });

        respuesta.shift();
        self.listImportGuides = respuesta;
        self.validateContent();


      }).catch(error => {
        console.error(error);
        errorHappen = true;
      });

    }
    if (errorHappen) {
      this.blocked = false;
    }
    this.blocked = false;
  }


  /**
   * The `validateContent` function processes data from a list of external guides, validates various
   * fields, and displays error messages if any validation fails.
   */
  validateContent() {
    this.blocked = true;

    this.listExternGuides = this.listImportGuides.map(guidexls => this.mapGuide(guidexls as any));

    this.checkValidationErrors();

    this.blocked = false;
  }

  /**
   * The function `mapGuide` maps data from an array to an object representing a guide and performs
   * various validations on the guide object.
   * @param {any[]} guidexls - The `guidexls` parameter in the `mapGuide` function is an array containing
   * data for mapping to an `ExternGuidesDocument` object. Each element in the array corresponds to a
   * specific property of the `ExternGuidesDocument` object. The function maps the data from the array to
   * @returns The function `mapGuide` is returning an object of type `ExternGuidesDocument` with
   * properties assigned values from the `guidexls` array. The object contains information about a guide
   * such as guideId, guideName, email, mobilePhone, nationality, currentRole, currentLevel, and other
   * details. The function also performs validation checks on some of the guide properties before
   * returning the guide object
   */
  private mapGuide(guidexls: any[]): ExternGuidesDocument {

    const guide: ExternGuidesDocument = {
      guideId: guidexls[0],
      guideName: guidexls[1],
      lastName: guidexls[2],
      email: guidexls[3],
      mobilePhone: guidexls[4],
      otherPhone: guidexls[5],
      guideType: guidexls[6],
      nationality: guidexls[7],
      residenCountry: guidexls[8],
      zone: guidexls[9],
      national: guidexls[10],
      local: guidexls[11],
      localCountry: guidexls[12],
      localState: guidexls[13],
      localCity: guidexls[14],
      currentRole: guidexls[15],
      currentLevel: guidexls[16],
      zoneExperience: guidexls[17],
      natioExperience: guidexls[18],
      sendingYear: guidexls[19],
      sendingMonth: guidexls[20],
      sendingDay: guidexls[21],
      maleFemale: guidexls[22],
      currentJob: guidexls[23],
      spokenlanguage: guidexls[24],
      countryAddress: guidexls[25],
      stateAddress: guidexls[26],
      cityAddress: guidexls[27],
      birthYear: guidexls[28],
      brithMonth: guidexls[29],
      birthDay: guidexls[30],
      storeId: this.device === 'USA' ? "0000000056" : this.security.storeId
    };

    this.validateEmail(guide);
    this.validateGuideType(guide);
    this.validateCurrentLevel(guide);
    this.validateCurrentRole(guide);
    this.validateZoneExperience(guide);
    this.validateNatioExperience(guide);
    this.validateGender(guide);
    this.validateZone(guide);

    return guide;
  }

  /**
 * The function `validateEmail` checks if the email in the provided guide is valid and updates the
 * `isValidEmail` property accordingly.
 * @param {ExternGuidesDocument} guide - The `guide` parameter in the `validateEmail` function is of
 * type `ExternGuidesDocument`. It seems to be an object that contains information about a guide,
 * including an email address that needs to be validated. The function checks if the email address is a
 * non-empty string and then validates its
 */
  private validateEmail(guide: ExternGuidesDocument) {
    if (this.tovpilUtils.isNonEmptyString(guide.email)) {
      guide.isValidEmail = this.tovpilUtils.isEmailValido(guide.email);
    } else {
      guide.isValidEmail = true;
    }
  }

  /**
   * The function `validateGuideType` checks if a given guide type is valid and updates its status
   * accordingly.
   * @param {ExternGuidesDocument} guide - The `validateGuideType` function takes a parameter `guide` of
   * type `ExternGuidesDocument`. This function checks if the `guideType` property of the `guide` object
   * matches any `descripTo` property in the `lstTypesGuide` array. If a match is found
   */
  private validateGuideType(guide: ExternGuidesDocument) {

    // if (this.device === 'USA' && guide.guideType === 'EA') {
    //   guide.guideType = 'E';
    // }

    const catGuiType = this.lstTypesGuide.find(x =>
      (x.descripTo || " ").toLowerCase() == ((guide.guideType || " ").toLowerCase()) ||
      (x.fieldVal || " ").toLowerCase() == ((guide.guideType || " ").toLowerCase())
    );

    if (catGuiType) {
      guide.isValidStatusGuide = true;
      guide.guideType = `${catGuiType.fieldVal}-${guide.guideType}`;
    } else {
      guide.isValidStatusGuide = false;
    }
  }

  /**
   * The function `validateCurrentLevel` in TypeScript validates the current level of a guide based on a
   * list of level types.
   * @param {ExternGuidesDocument} guide - The `guide` parameter in the `validateCurrentLevel` function
   * is of type `ExternGuidesDocument`.
   */
  private validateCurrentLevel(guide: ExternGuidesDocument) {
    const catLevelType = this.lstLevelTypes.find(x =>
      (x.descripTo || " ").toLowerCase() == ((guide.currentLevel || " ").toLowerCase()) ||
      (x.fieldVal || " ").toLowerCase() == ((guide.currentLevel || " ").toLowerCase())
    );


    if (catLevelType) {
      guide.currentLevel = `${catLevelType.fieldVal}-${guide.currentLevel}`;
      guide.isValidlevel = true;
    } else {
      guide.isValidlevel = !this.tovpilUtils.isNonEmptyString(guide.currentLevel);
    }
  }

  /**
   * The function `validateCurrentRole` checks if the current role of a guide matches a predefined
   * category and updates it accordingly.
   * @param {ExternGuidesDocument} guide - The `guide` parameter in the `validateCurrentRole` function is
   * of type `ExternGuidesDocument`.
   */
  private validateCurrentRole(guide: ExternGuidesDocument) {
    let catFuncType = null;
    if (this.device === 'USA') {
      if (guide.currentRole.toString().toLowerCase().trim().includes('materials guide')) {
        guide.currentRole = 'Materials in charge';
      } else if (guide.currentRole.toString().toLowerCase().trim().includes('guide responsible for school')) {
        guide.currentRole = 'school Pre Gui';
      } else if (guide.currentRole.toString().toLowerCase().trim().includes('young adults guide')) {
        guide.currentRole = 'Young';
      } else {
        guide.currentRole = guide.currentRole;
      }

      catFuncType = this.lstFuncTypes.find(x =>
        (x.descripTo || " ").toLowerCase() == ((guide.currentRole || " ").toLowerCase()) ||
        (guide.currentRole || " ").toLowerCase() == 'guide'
      );

    } else {
      catFuncType = this.lstFuncTypes.find(x =>
        (x.descripTo || " ").toLowerCase() == ((guide.currentRole || " ").toLowerCase()) ||
        (x.fieldVal || " ").toLowerCase() == ((guide.currentRole || " ").toLowerCase()));

    }

    if (catFuncType) {
      guide.currentRole = `${catFuncType.fieldVal}-${guide.currentRole}`;
      guide.isValidFunction = true;
    } else {
      guide.isValidFunction = !this.tovpilUtils.isNonEmptyString(guide.currentRole);
    }
  }

  /**
   * The function `validateZoneExperience` in TypeScript validates a guide's zone experience based on a
   * predefined list of values.
   * @param {ExternGuidesDocument} guide - The `guide` parameter in the `validateZoneExperience` function
   * is of type `ExternGuidesDocument`. It is used to validate the zone experience of a guide. The
   * function checks if the `zoneExperience` of the guide matches a value in the `lstYesNo01` array and
   * updates
   */
  private validateZoneExperience(guide: ExternGuidesDocument) {
    const catYesNo = this.lstYesNo01.find(x =>
      (x.descripTo || " ").toLowerCase() == ((guide.zoneExperience || "N").toLowerCase()) ||
      (x.fieldVal || " ").toLowerCase() == ((guide.zoneExperience || "N").toLowerCase())
    );


    if (catYesNo) {
      guide.zoneExperience = `${catYesNo.fieldVal}-${guide.zoneExperience}`;
      guide.isValidExperZone = true;
    } else {
      guide.isValidExperZone = !this.tovpilUtils.isNonEmptyString(guide.zoneExperience);
    }
  }

  /**
   * The function `validateNatioExperience` in TypeScript validates a field in an object based on a
   * predefined list of values.
   * @param {ExternGuidesDocument} guide - The `guide` parameter in the `validateNatioExperience`
   * function is of type `ExternGuidesDocument`. It seems to be used to validate the national experience
   * of a guide. The function checks if the `guide.natioExperience` matches a value in the `lstYesNo01`
   * array
   */
  private validateNatioExperience(guide: ExternGuidesDocument) {
    const catYesNo = this.lstYesNo01.find(x =>
      (x.descripTo || " ").toLowerCase() == ((guide.natioExperience || "N").toLowerCase()) ||
      (x.fieldVal || " ").toLowerCase() == ((guide.natioExperience || "N").toLowerCase())
    );

    if (catYesNo) {
      guide.natioExperience = `${catYesNo.fieldVal}-${guide.natioExperience}`;
      guide.isValidExperNac = true;
    } else {
      guide.isValidExperNac = !this.tovpilUtils.isNonEmptyString(guide.natioExperience);
    }
  }

  /**
   * The function `validateGender` in TypeScript validates the gender field of a guide document by
   * checking if it matches a predefined list of genders.
   * @param {ExternGuidesDocument} guide - The `guide` parameter is of type `ExternGuidesDocument`, which
   * seems to contain information related to a guide. The function `validateGender` is used to validate
   * the gender information within this guide document. It checks if the gender specified in the guide
   * matches any gender in the `lstGender`
   */
  private validateGender(guide: ExternGuidesDocument) {
    const catGender = this.lstGender.find(x =>
      (x.descripTo || " ").toLowerCase() == ((guide.maleFemale || " ").toLowerCase()) ||
      (x.fieldVal || " ").toLowerCase() == ((guide.maleFemale || " ").toLowerCase())
    );

    if (catGender) {
      guide.maleFemale = `${catGender.fieldVal}-${guide.maleFemale}`;
      guide.isValidGender = true;
    } else {
      guide.isValidGender = !this.tovpilUtils.isNonEmptyString(guide.maleFemale);
    }
  }

  /**
   * The function `validateZone` checks if a guide's zone is a non-empty string and assigns a
   * corresponding store ID if found in a list of zones.
   * @param {ExternGuidesDocument} guide - The `guide` parameter is of type `ExternGuidesDocument`, which
   * likely contains information related to external guides. The function `validateZone` checks if the
   * `guide` object has a non-empty `zone` property. If it does, it searches for a matching `descripTo`
   */
  private validateZone(guide: ExternGuidesDocument) {
    if (this.tovpilUtils.isNonEmptyString(guide.zone)) {
      const catZones = this.lstZones.find(x =>
        (x.descripTo || " ").toLowerCase() == ((guide.zone || " ").toLowerCase()) ||
        (x.fieldVal || " ").toLowerCase() == ((guide.zone || " ").toLowerCase())
      );


      if (catZones) {
        guide.storeId = catZones.fieldVal;
      }
    }
  }

  /**
   * The function `checkValidationErrors` filters out guides with validation errors and displays error
   * messages if any errors are found.
   */
  private checkValidationErrors() {
    const errorsEmail = this.listExternGuides.filter(guide => !guide.isValidEmail);
    const errorsTypeGuide = this.listExternGuides.filter(guide => !guide.isValidStatusGuide);
    const errorsLevel = this.listExternGuides.filter(guide => !guide.isValidlevel);
    const errorsFunction = this.listExternGuides.filter(guide => !guide.isValidFunction);
    const errorsExperZon = this.listExternGuides.filter(guide => !guide.isValidExperZone);
    const errorsExperNac = this.listExternGuides.filter(guide => !guide.isValidExperNac);
    const errorsGender = this.listExternGuides.filter(guide => !guide.isValidGender);

    this.haserrors = errorsEmail.length > 0 || errorsTypeGuide.length > 0 || errorsLevel.length > 0 ||
      errorsFunction.length > 0 || errorsExperZon.length > 0 || errorsExperNac.length > 0 || errorsGender.length > 0;

    if (this.haserrors) {
      this.listExternGuides.sort((a, b) => Number(a.isValidEmail) - Number(b.isValidEmail));
    }

    this.displayErrorMessages(errorsEmail, errorsTypeGuide, errorsLevel, errorsFunction, errorsExperZon, errorsExperNac, errorsGender);
  }

  /**
   * This function displays error messages for different types of validation errors related to email,
   * type guide, level, function, experience zone, experience national team, and gender.
   * @param {ExternGuidesDocument[]} errorsEmail - The `displayErrorMessages` method takes in several
   * arrays of `ExternGuidesDocument` objects as parameters. These arrays are used to display error
   * messages for different types of validation errors related to email, type of guide, level, function,
   * experience in a zone team, experience in a national team,
   * @param {ExternGuidesDocument[]} errorsTypeGuide - The `errorsTypeGuide` parameter in the
   * `displayErrorMessages` function seems to be an array of `ExternGuidesDocument` objects that
   * represent errors related to the type of guide. The function checks if there are any errors in this
   * array and displays an error message accordingly.
   * @param {ExternGuidesDocument[]} errorsLevel - The `errorsLevel` parameter in the
   * `displayErrorMessages` function represents an array of `ExternGuidesDocument` objects that contain
   * errors related to the level of a guide. When there are elements in this array, it means that there
   * are guides with invalid levels. The function then displays an error
   * @param {ExternGuidesDocument[]} errorsFunction - The `errorsFunction` parameter in the
   * `displayErrorMessages` function seems to be an array of `ExternGuidesDocument` objects that
   * represent errors related to functions. When this function is called, it checks if there are any
   * errors in the `errorsFunction` array and displays an error message using
   * @param {ExternGuidesDocument[]} errorsExperZon - The `errorsExperZon` parameter in the
   * `displayErrorMessages` function seems to be an array of `ExternGuidesDocument` objects that
   * represent errors related to experience in a specific zone or team. When this function is called, it
   * checks if there are any errors in this array and
   * @param {ExternGuidesDocument[]} errorsExperNac - The parameter `errorsExperNac` seems to be an array
   * of `ExternGuidesDocument` objects that represent errors related to national team experience. The
   * `displayErrorMessages` method takes in several arrays of `ExternGuidesDocument` objects representing
   * different types of errors and displays error messages based
   * @param {ExternGuidesDocument[]} errorsGender - The `errorsGender` parameter in the
   * `displayErrorMessages` function seems to be an array of `ExternGuidesDocument` objects that
   * represent errors related to gender validation. When this function is called, it checks if there are
   * any errors in the `errorsGender` array and displays an error message
   */
  private displayErrorMessages(errorsEmail: ExternGuidesDocument[], errorsTypeGuide: ExternGuidesDocument[], errorsLevel: ExternGuidesDocument[], errorsFunction: ExternGuidesDocument[], errorsExperZon: ExternGuidesDocument[], errorsExperNac: ExternGuidesDocument[], errorsGender: ExternGuidesDocument[]) {
    if (errorsEmail.length > 0)
      this.messageService.add({ severity: 'error', summary: 'Validación Archivo', detail: `${this.translations.lbl_there_are} ${errorsEmail.length} ${this.translations.lbl_email} invalidos`, life: 5000 });
    if (errorsTypeGuide.length > 0)
      this.messageService.add({ severity: 'error', summary: 'Validación Archivo', detail: `${this.translations.lbl_there_are} ${errorsTypeGuide.length} con tipo guia invalido`, life: 5000 });
    if (errorsLevel.length > 0)
      this.messageService.add({ severity: 'error', summary: 'Validación Archivo', detail: `${this.translations.lbl_there_are} ${errorsLevel.length} con ${this.translations.lbl_level} ${this.translations.lbl_function} no validos`, life: 5000 });
    if (errorsFunction.length > 0)
      this.messageService.add({ severity: 'error', summary: 'Validación Archivo', detail: `${this.translations.lbl_there_are} ${errorsFunction.length} con ${this.translations.lbl_function} no validos`, life: 5000 });
    if (errorsExperZon.length > 0)
      this.messageService.add({ severity: 'error', summary: 'Validación Archivo', detail: `${this.translations.lbl_there_are} ${errorsExperZon.length} con ${this.translations.lbl_any_zone_team_experience} no validos`, life: 5000 });
    if (errorsExperNac.length > 0)
      this.messageService.add({ severity: 'error', summary: 'Validación Archivo', detail: `${this.translations.lbl_there_are} ${errorsExperNac.length} con ${this.translations.lbl_any_natio_team_experience} no validos`, life: 5000 });
    if (errorsGender.length > 0)
      this.messageService.add({ severity: 'error', summary: 'Validación Archivo', detail: `${this.translations.lbl_there_are} ${errorsGender.length} con ${this.translations.lbl_gender} no validos`, life: 5000 });
  }

  /**
   * The function `getCatalogTypesGuides` asynchronously retrieves various category language data based
   * on device and stores them in corresponding lists.
   */
  async getCatalogTypesGuides() {
    let catLang: string = "es";
    if (this.device == "BR") {
      catLang = 'pt';
    } else if (this.device == "USA") {
      catLang = 'en';
    }
    let guideStatus = await this.apiService.getCategoryLang({
      'language': catLang,
      'fieldId': "guideSts"
    });
    this.lstTypesGuide = guideStatus;

    let levels = await this.apiService.getCategoryLang({
      'language': catLang,
      'fieldId': "level"
    });
    this.lstLevelTypes = levels;

    let functions = await this.apiService.getCategoryLang({
      'language': catLang,
      'fieldId': "Function"
    });
    this.lstFuncTypes = functions;

    let yesNo = await this.apiService.getCategoryLang({
      'language': catLang,
      'fieldId': "YesNo01"
    });
    this.lstYesNo01 = yesNo;

    let genres = await this.apiService.getCategoryLang({
      'language': catLang,
      'fieldId': "sex"
    });
    this.lstGender = genres;

    let zonePlatFo = await this.apiService.getCategoryLang({
      'language': catLang,
      'fieldId': "zoneplatfo"
    });
    this.lstZones = zonePlatFo;
  }

  /**
   * The function `uploadGuides` prompts a confirmation dialog and upon acceptance, creates a list of
   * external guides, saves a file, and displays a success message.
   */
  uploadGuides() {
    this.confirmationService.confirm({
      message: this.translations.lbl_wish_to_continue + ' ?',
      header: this.translations.lbl_send + ' ' + this.translations.lbl_file + ' ' + this.translations.lbl_guides,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.blocked = true;;
        this.apiService.createListExternGuides(this.listExternGuides).then(reponseCreate => {
          this.haserrors = true;
          this.saveFile();
          this.listExternGuides = [];
          this.blocked = false;
          this.messageService.add({ severity: 'success', summary: 'Upload Excel', detail: ' ' + this.translations.lbl_file + ' ' + this.translations.lbl_guides + ' / ' + this.device + ' ' + this.translations.lbl_sent_to + ' TOV Internacional', life: 3000 });
        });
      }
    });
  }

  /**
   * The `saveFile` function reads a selected file, converts it to base64 format, and then sends it to an
   * API service for saving.
   */
  saveFile() {
    this.blocked = true;
    if (this.selectedFile) {
      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        let array = (<string>reader.result).split(",");
        this.apiService.saveFileSantoApp({
          "nameFile": this.device + "_guides_" + this.tovpilUtils.dateToTovpilDate(new Date()) + "." + this.selectedFile.name.split(".")[1],
          "base64File": array[1],
          "folderId": "EXTERGUIDE"
        }).then(
          data => {
          })
      };
    }
    this.blocked = false;
  }

  uploadedFiles: any[] = [];

  clearTable() {
    this.listExternGuides = [];
    this.listImportGuides.length = 0;
    this.uploadedFiles = [];
  }

  onUpload(event) {
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }
    // Opcional: mensaje de éxito
    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
  }

  capitalizeFirstLetter(inputString) {
    if (inputString.length > 0) {
      return inputString.charAt(0).toUpperCase() + inputString.slice(1);
    } else {
      return inputString;
    }
  }

}
